import { Outlet, useLocation, useNavigate } from 'react-router-dom-v6'
import { useTranslation } from 'react-i18next'
import { Button, Separator, SidebarInset, SidebarProvider, SidebarTrigger } from '@clouway/ui'
import { ArrowLeft } from 'lucide-react'
import AppSidebar from './AppSidebar'
import ModeToggle from './ModeToggle'
import { UserMenu } from './UserMenu'

function AppLayout() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // History back from any screen except the home (customers) root.
  const canGoBack = pathname !== '/'

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          {canGoBack && (
            <Button
              variant="ghost"
              size="icon"
              aria-label={t('ui.button.back')}
              onClick={() => navigate(-1)}
            >
              <ArrowLeft className="size-4" />
            </Button>
          )}
          <div className="ml-auto flex items-center gap-1">
            <ModeToggle />
            <UserMenu />
          </div>
        </header>
        <div className="flex flex-1 flex-col p-4">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}

export default AppLayout
